<unity-breadcrumbs>
  @for (item of items; track item) {
    <li unity-breadcrumbs-item>
      <a [routerLink]="[item.link]" class="em-c-breadcrumbs__link">{{
        item.text
      }}</a>
    </li>
  }
</unity-breadcrumbs>
